
export const formatNumber = function(number: number, decimals: number = 1) {
    return (new Intl.NumberFormat(undefined, { maximumFractionDigits: decimals })).format(number)
}
